import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EventBusService } from '@ups/xplat/core';

import { HeaderBaseComponent } from '@ups/xplat/features';

@Component({
  selector: 'ups-header',
  templateUrl: 'header.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent extends HeaderBaseComponent {
  constructor(eventBus: EventBusService) {
    super(eventBus);
  }
}
